import { logger } from "@domain/infrastructure/logger";

declare let safari: any;
declare let InstallTrigger: any;

export class BrowserDetection {
    // https://stackoverflow.com/questions/3007480/determine-if-user-navigated-from-mobile-safari
    static readonly isMobileSafari = () => {
        return navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/);
    };
    // https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
    static readonly isSafari =
        BrowserDetection.isMobileSafari() ||
        /constructor/i.test((window as any).HTMLElement) ||
        (function (p) {
            return p.toString() === "[object SafariRemoteNotification]";
        })(!(window as any).safari || (typeof safari !== "undefined" && safari.pushNotification));
    static readonly isFirefox = typeof InstallTrigger !== "undefined";
}

export class ScrollbarDetection {
    protected static width = 0;

    static runDetector() {
        const scrollDiv = document.createElement("div");
        scrollDiv.className = "scrollbar-measure";
        document.body.appendChild(scrollDiv);

        const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        this.width = scrollbarWidth; // Mac:  15

        document.body.removeChild(scrollDiv);
    }

    static getWidth() {
        return this.width;
    }
}

/**
 * Identifies one *login*, not one device.
 *
 * Simultaneous-login control works as a last-writer-wins slot: each login writes
 * its own id to usersSessions/{uid} and every other session sees its id replaced
 * and signs out. That only needs uniqueness per login. It used to use a
 * FingerprintJS visitor id plus a WebRTC-scraped local IP, which is stable per
 * device - so a second login on the *same* machine wrote an identical value and
 * evicted nobody. A random id per login is both correct and non-identifying.
 */
export const createSessionId = (): string => crypto.randomUUID();

/**
 * Coarse, non-identifying label ("Chrome · macOS") so the sign-out notice can say
 * what took over. Deliberately low-resolution: it must not become a device
 * fingerprint.
 */
export const getDeviceLabel = (): string => {
    const ua = navigator.userAgent;
    const browser = BrowserDetection.isFirefox
        ? "Firefox"
        : /Edg\//.test(ua)
          ? "Edge"
          : /OPR\//.test(ua)
            ? "Opera"
            : /Chrome\//.test(ua)
              ? "Chrome"
              : BrowserDetection.isSafari
                ? "Safari"
                : "Browser";
    const os = /Windows/.test(ua)
        ? "Windows"
        : /Android/.test(ua)
          ? "Android"
          : /(iPhone|iPad|iPod)/.test(ua)
            ? "iOS"
            : /Mac OS X/.test(ua)
              ? "macOS"
              : /Linux/.test(ua)
                ? "Linux"
                : "";
    return os ? `${browser} · ${os}` : browser;
};

export function checkScrollbars() {
    const scrollDiv = document.createElement("div");
    scrollDiv.className = "scrollbar-measure";
    document.body.appendChild(scrollDiv);

    // Get the scrollbar width
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    logger.warning("checkScrollbars", scrollbarWidth); // Mac:  15

    // Delete the DIV
    document.body.removeChild(scrollDiv);
}
